module.exports = __webpack_public_path__ + "img/icomoon.4bc0953.svg";